import React from 'react';
import { connect } from 'react-redux';

import { interfaceActions } from '../../../../../common/redux/actions';
import * as URLs from '../../../../../common/constants/systemUrls';
import AddPerformerData from '../../../components/MyPerformers/AddPerformer/AddPerformerInfo';
import progresses from '../../../components/MyPerformers/AddPerformer/progress';

import { selectDadataSelected } from '../../../../Authorization/selectors';

const { setCaption } = interfaceActions;
function hasErrors(fieldsError) {
  return fieldsError
    ? Object.keys(fieldsError).some(field => fieldsError[field])
    : false;
}
class AddPerformer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditable: true,
      formProgress: [...progresses.default],
    };
    this.forms = {};
  }
  componentDidMount() {
    this.setCaption(true);
  }
  setCaption(flagUpdate = false) {
    if (flagUpdate) {
      let title = 'Добавление исполнителя';
      if (title) {
        this.props.setCaption({
          enabled: true,
          mainCaption: title,
          breadCrumbs: [
            {
              path: '/' + URLs.CONTROL_PANEL,
              breadcrumbName: 'Панель управления',
            },
            {
              path: '/' + URLs.SYSTEM_SETTINGS + '/performers',
              breadcrumbName: 'Настройки системы - Мои исполнители',
            },
            {
              path: '/' + URLs.ADD_PERFORMER,
              breadcrumbName: 'Добавление исполнителя',
            },
          ],
        });
      }
    }
  }
  setForm = (name, form) => {
    if (form) {
      return (this.forms[name] = form);
    } else {
      delete this.forms[name];
      return false;
    }
  };

  getForm = name => {
    if (this.forms.hasOwnProperty(name)) {
      return this.forms[name];
    }
    return false;
  };

  updateProgress = (values, Name) => {
    const form = this.getForm(Name);
    if (form) {
      let updateProgress = [];
      Object.keys(values).forEach(name => {
        // Ищем к какой группе относится измененное поле
        let progressItem =
          this.state.formProgress[Name] &&
          this.state.formProgress[Name].find(progress => {
            let result = false;
            // Проходимся по обязательным полям
            if (progress.fields) {
              let fields = Array.isArray(progress.fields[0])
                ? progress.fields
                : [progress.fields];

              result = fields.some(groups =>
                groups.some(groupFields => groupFields.indexOf(name) !== -1)
              );
              if (result) return result;
            }
            // Если не нашли в обязательных полях просматриваем в полях для descriptions
            if (!result && progress.fieldsDesc) {
              return progress.fieldsDesc.some(
                groupFields => groupFields.indexOf(name) !== -1
              );
            }
            return false;
          });

        // Если нашли группу, начинаем проверять поля на заполненность
        if (progressItem) {
          let description, fieldsValue;

          // Проверяем обязательные поля на наличие ошибок
          let groupСompleted = false;

          let groupFields = Array.isArray(progressItem.fields[0])
            ? progressItem.fields
            : [progressItem.fields];
          groupFields.forEach(fields => {
            if (!groupСompleted) {
              groupСompleted = !hasErrors(form.getFieldsError(fields));
              if (groupСompleted) {
                // Группа без ошибок
                // Проверяем на наличие пустых значений
                fieldsValue = form.getFieldsValue(fields);
                if (
                  Object.keys(fieldsValue).some(field =>
                    Array.isArray(fieldsValue[field])
                      ? fieldsValue[field].length === 0
                      : !fieldsValue[field]
                  )
                ) {
                  groupСompleted = false; // В группе есть незаполненные поля, которые являются обязательными
                }
              }
            }
          });

          // Если группа без ошибок, сохраняем данные для description
          if (groupСompleted) {
            fieldsValue =
              (progressItem.fieldsDesc &&
                form.getFieldsValue(progressItem.fieldsDesc)) ||
              fieldsValue;
            description = Object.keys(fieldsValue).reduce((desc, name) => {
              return desc + (desc !== '' ? ', ' : '') + fieldsValue[name];
            }, '');
          }

          updateProgress.push({
            name: progressItem.name,
            completed: groupСompleted,
            fieldsValue,
            description,
          });
        }
      });

      if (updateProgress.length > 0) {
        this.setState((state, props) => {
          let { formProgress } = state;
          let newFormProgress = Object.assign({}, formProgress);
          let flagUpdate = false;
          updateProgress.forEach(group => {
            const itemIndex =
              newFormProgress[Name] &&
              newFormProgress[Name].findIndex(item => item.name === group.name);
            if (
              itemIndex !== -1 &&
              (newFormProgress[Name][itemIndex].completed !== group.completed ||
                newFormProgress[Name][itemIndex].description !==
                  group.description)
            ) {
              flagUpdate = true;
              newFormProgress[Name] = [
                ...newFormProgress[Name].slice(0, itemIndex),
                Object.assign({}, newFormProgress[Name][itemIndex], group),
                ...newFormProgress[Name].slice(itemIndex + 1),
              ];
            }
          });
          if (flagUpdate) {
            return { formProgress: newFormProgress };
          } else {
            return {};
          }
        });
      }
    }
  };

  render() {
    const { dadataSelected } = this.props;
    console.log('formProgress', this.state.formProgress);
    return (
      <AddPerformerData
        {...this.props}
        name="formAddPerformer"
        data={dadataSelected}
        setForm={this.setForm}
        getForm={this.getForm}
        isEditable={this.state.isEditable}
        progress={this.state.formProgress}
        updateProgress={this.updateProgress}
      />
    );
  }
}

export default connect(
  state => ({
    dadataSelected: selectDadataSelected(state),
  }),
  {
    setCaption,
  }
)(AddPerformer);
